<template>
  <div>
    <div class="app-title">
      <div>
        <h2>{{$t('tlt.inventory.adjustInventory')}}</h2>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">
              <i class="fa fa-home"></i>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/inventory/rawMaterial">
              <span>{{$t('tlt.inventory.inventory')}}</span>
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="#">
              <span>{{$t('tlt.inventory.adjustInventory')}}</span>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
            data-parent="#accordionFilter"
          >
            <div class="card-body">
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.matCode')}}:</label>
                  <dimsearch
                    v-model="matCodeFilter"
                    :entity="materials"
                    bindId="adjMaterialFilter"
                    bindProp="matCode"
                    submitProp="matCode"
                  ></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.matName')}}:</label>
                  <dimsearch :entity="materials" bindId="adjMaterialFilter" bindProp="matName"></dimsearch>
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.adjustPerson')}}:</label>
                  <input class="form-control" type="text" v-model="adjPersonFilter" />
                </div>
              </form>
              <form class="row">
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.invCode')}}</label>
                  <dimsearch
                    v-model="locationCodeFilter"
                    :entity="locations"
                    bindId="adjLocationFilter"
                    bindProp="code"
                    submitProp="code"
                  ></dimsearch>
                </div>

                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.inventory.invName')}}：</label>
                  <dimsearch :entity="locations" bindId="adjLocationFilter" bindProp="locName"></dimsearch>
                </div>

                <div class="form-group col-md-2" id="div1">
                  <label class="control-label">{{$t('lbl.basic.stDate')}}:</label>
                  <!--input class="form-control" type="Date" v-model="adjStimeFilter"/-->
                  <date-picker v-model="adjStimeFilter" />
                </div>
                <div class="form-group col-md-2">
                  <label class="control-label">{{$t('lbl.basic.endDate')}}:</label>
                  <!--input class="form-control" type="Date" v-model="adjEtimeFilter"/-->
                  <date-picker v-model="adjEtimeFilter" />
                </div>

                <div class="col-lg-4 align-self-end">
                  <div class="float-lg-right">
                    <button
                      class="btn btn-outline-secondary mr-1"
                      type="button"
                      v-on:click="clearFilter()"
                    >
                      <i class="fa fa-fw fa-lg fa-eraser"></i>
                      <span class="text">{{ $t("btn.basic.clear") }}</span>
                    </button>
                    <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('adjust')">
                      <!--button class="btn btn-primary" type="button" v-on:click="saveNew()"-->
                      <i class="fa fa-fw fa-lg fa-search"></i>
                      <span class="text">{{$t('btn.basic.search')}}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="adjustResultTable" class="content">
        <div class="card my-1">
          <div
            id="collapseTwo"
            class="collapse show"
            aria-labelledby="headingTwo"
            data-parent="#accordionResult"
          >
            <div class="card-body">
              <mmf-table entity="adjust" inline-actions-disabled 
              checkboxColumnDisabled
              disableEdit
              disableDelete
              ></mmf-table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import { gridFields, filterFields } from "@/model/prd/inventoryMgt/Adjust";
import MmfTable from "@/components/MmfTable";
import datePicker from "@/components/MmfDatepicker";
import dimsearch from "@/components/MMFDimSearch";

const { mapFields } = createHelpers({
  getterType: "adjust/getField",
  mutationType: "adjust/updateField"
});

export default {
  name: "adjust",
  data() {
    return {
      checkedItems: [],
      locations: [],
      materials: []
    };
  },
  components: {
    MmfTable,
    datePicker,
    dimsearch
  },
  computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.adjust.rows,
      tableColumns: gridFields,
      childs: state => state.adjust.childs
    })
  },
  methods: {
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    clearFilter() {
      this.$store.dispatch("dimSearch/initBind", { adjLocationFilter: {} }),
        this.$store.dispatch("dimSearch/initBind", { adjMaterialFilter: {} }),
        this.MMFClearFilter("adjust");
    }
  },
  mounted() {
    //    // this.MMFLoadRows('adjust');
    this.$store
      .dispatch(
        "api/get",
        {
          url:
            this.$store.state.location.baseModuleUrl + "/location/findByPerId"
        },
        {
          root: true
        }
      )
      .then(data => {
        data.push({
          code: "ALL",
          locName: "全部"
        });
        this.locations = data;
      }),
      this.$store
        .dispatch(
          "api/get",
          {
            url: this.$store.state.location.baseModuleUrl + "/material/findAll"
          },
          {
            root: true
          }
        )
        .then(data => {
          data.push({
            matCode: "ALL",
            matName: "全部"
          });
          this.materials = data;
        });
  }
};
</script>
